module.exports = __webpack_public_path__ + "media/images/default/shared/footer/bg-md-66f16a4a36f1385dc5badfc01bd28e6e.svg";